module.exports = __webpack_public_path__ + "rosacea_6_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/rosacea_6_after.jpg
// module id = 987
// module chunks = 0